import { COLORS } from '../../../../utils/colors';

export const useHeaderStyles = () => {
  return {
    navbarLogo: { height: '5rem', paddingLeft: 0, marginLeft: 0 },
    navbarIcons: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '1rem',
    },
    navbarIcon: {
      fontSize: '2.5625rem',
    },
    tabs: {
      '.MuiTab-root.Mui-selected': {
        color: '#fff',
      },
      '& .MuiTabs-indicator': {
        backgroundColor: '#fff !important',
      },
      '& .MuiTab-root': {
        color: '#fff',
      },
    },
    appBar: {
      backgroundColor: COLORS.BACKGROUND_NEW,
      height: '3.625rem',
      display: 'flex',
      justifyContent: 'center',
      position: 'sticky',
      top: 0,
      zIndex: 99,
      '& .MuiToolbar-root': {
        minHeight: '1rem',
        paddingRight: 0,
      },
    },
    navbarBooking: {
      textTransform: 'none',
      marginRight: '0.5rem',
      padding: '0.25rem 0.8rem',
      //backgroundColor: '#fff',
      backgroundImage: 'none',
      //color: COLORS.PRIMARY,
      fontWeight: 600,
      color: '#fff',
      //padding: '.375rem 1rem',
      borderRadius: '1.5rem',
      border: '1px solid #fff',
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: '#fff',
        color: COLORS.PRIMARY,
      },
    },
    joinModal: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '25rem',
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
      borderRadius: '1rem',
      padding: '1rem',
    },
  };
};
